import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from 'services/baseQuery';

export const infoApi = createApi({
  baseQuery: customBaseQuery,
  reducerPath: 'infoApi',
  tagTypes: ['Info'],
  endpoints: (builder) => ({
    getCompanyInfo: builder.query({
      query: () => ({
        url: '/companies',
        method: 'GET',
      })
    }),
    getCompanyServices: builder.query({
      query: () => ({
        url: '/company_services',
        method: 'GET',
      })
    }),
    updateCompanyInfo: builder.mutation({
      query: (ids) => ({
        url: '/companies',
        method: 'PUT',
        body: {
          company_service_ids: ids
        }
      })
    })
  })
});

export const {
  usePrefetch,
  useGetCompanyInfoQuery,
  useGetCompanyServicesQuery,
  useUpdateCompanyInfoMutation
} = infoApi;
